import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { StepId } from '@types'
import { RootState } from 'redux/store'

// Define a type for the slice state
type QuizFormState = Record<string, any>
type QuizAnswers = Record<string, any>

// Define the initial state using that type
const initialState: QuizFormState = {}

export const formState = createSlice({
  name: 'quizFormState',
  initialState,
  reducers: {
    setStepValue: (
      state,
      action: PayloadAction<{ stepId: StepId; value: any }>,
    ) => {
      state[action.payload.stepId] = action.payload.value
    },
    setQuizAnswers: (state, action: PayloadAction<QuizAnswers>) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    reset: () => initialState,
  },
})

export const { setStepValue, setQuizAnswers, reset } = formState.actions

export const selectStepValue = (state: RootState, stepId: StepId): any => {
  return (state.quiz.formState as QuizFormState)[stepId]
}

export default formState.reducer
